/* eslint-disable no-console */

import { register } from 'register-service-worker'

const buildVersion = process.env.VUE_APP_COMMIT_ID || '0.1'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js?v=${buildVersion}`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      // Check for updates setiap halaman di-load
      registration.update()
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; refreshing...')
      // if (registration && registration.waiting) {
      //   registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      // }
      // setTimeout(() => reloadPage(), 1000)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
